import React, { FC } from 'react';
import { useScrollToTop } from '../../../../../hooks/useScrollToTop';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import AvailableBookingPages from '../AvailableBookingPageList';
import PurchaseBackToTop from '../PurchaseBackToTop';
import PurchaseTicketBookItemList from '../PurchaseTicketBookItemList';
import PurchaseSubscriptionItemList from '../PurchaseSubscriptionItemList';
import PurchaseVerifyUserAlert from '../PurchaseVerifyUserAlert';
import PurchaseCompleteAlert from '../PurchaseCompleteAlert';
import { Order } from '../../../../../interfaces/merchants/products/orders';
import { FirstCharge } from '../../../../../interfaces/merchants/products/firstCharge';
import { usePushPurchaseEventToDataLayer } from '../../../../../hooks/gtm';

interface Props {
  schemeType: IPurchases.SchemeType;
  product: IPurchases.MerchantProduct;
  firstCharge: FirstCharge | null;
  settings: IPurchases.SettingCompletion;
  lastOrder: Order | null;
  publicId: string;
}

const Completion: FC<Props> = (props: Props) => {
  useScrollToTop();
  const {
    schemeType,
    product,
    firstCharge,
    settings: { bookingPages, expiryDate, verifiedUser, customerPublicId },
    publicId,
  } = props;

  // Fire GTM booking_completion event
  usePushPurchaseEventToDataLayer({
    productId: product.publicId,
    customerId: customerPublicId,
  });

  const labelType =
    schemeType === IPurchases.SchemeType.Subscription
      ? 'subscription'
      : 'ticketBook';
  return (
    <>
      <PurchaseCompleteAlert labelType={labelType} />
      {!verifiedUser && <PurchaseVerifyUserAlert labelType={labelType} />}
      {schemeType === IPurchases.SchemeType.TicketBook && (
        <PurchaseTicketBookItemList
          productImage={
            product.image ? product.image.thumb && product.image.thumb.url : ''
          }
          productName={product.name}
          merchantId={props.publicId}
          ticketCount={product.ticketCount}
          price={product.price}
          expiryDate={expiryDate}
        />
      )}
      {schemeType === IPurchases.SchemeType.Subscription && (
        <PurchaseSubscriptionItemList
          productImage={
            product.image ? product.image.thumb && product.image.thumb.url : ''
          }
          productName={product.name}
          merchantId={props.publicId}
          waitFirstAnchor={product.waitFirstAnchor}
          firstCharge={firstCharge}
          price={product.price}
          availableMonthsPeriod={product.availableMonthsPeriod}
        />
      )}
      {bookingPages.length !== 0 && (
        <AvailableBookingPages
          publicId={publicId}
          bookingPages={bookingPages}
        />
      )}
      <PurchaseBackToTop publicId={publicId} />
    </>
  );
};

export default Completion;
